'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fullscreenItemPreload = require('./fullscreenItemPreload.js');

var _fullscreenItemPreload2 = _interopRequireDefault(_fullscreenItemPreload);

var _utils = require('../utils/utils');

var _fullscreen = require('@wix/photography-client-lib/dist/src/versioning/features/fullscreen');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenText = function (_React$Component) {
  (0, _inherits3.default)(FullscreenText, _React$Component);

  function FullscreenText() {
    (0, _classCallCheck3.default)(this, FullscreenText);
    return (0, _possibleConstructorReturn3.default)(this, (FullscreenText.__proto__ || (0, _getPrototypeOf2.default)(FullscreenText)).apply(this, arguments));
  }

  (0, _createClass3.default)(FullscreenText, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      try {
        if (typeof this.props.actions.setItemLoaded === 'function') {
          this.props.actions.setItemLoaded();
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item;
      var scale = Math.round(100 * (item.width / item.maxWidth) * this.props.window.scale.min(item)) / 100;
      var scaleFix = (scale - 1) / 2 * 100;
      var translate = this.props.isZoom ? 'translate(-50%, -50%)' : 'translate(' + scaleFix + '%, ' + scaleFix + '%)';

      return !this.props.isDummy ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_fullscreenItemPreload2.default, { item: item, loaded: true }),
        _react2.default.createElement('div', {
          className: 'fullscreen-content  fullscreen-item-visible fullscreen-item gallery-item-loaded pro-fullscreen-text-item',
          style: {
            width: item.maxWidth + 'px',
            height: item.maxHeight + 'px',
            WebkitTransform: _utils.utils.isMobile() && _fullscreen.fullscreenVersionManager.useFullscreenNewMobileLayout() ? translate + ' scale(' + scale + ')' : '',
            background: item.bgColor
          },
          key: 'text',
          dangerouslySetInnerHTML: { __html: item.html }
        })
      ) : _react2.default.createElement('div', null);
    }
  }]);
  return FullscreenText;
}(_react2.default.Component);

exports.default = FullscreenText;